import React from 'react';

const UtensilsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M18.75 3v15.75m-6.75-12.75v12.75M12 3v3.75m0 9v3M3 3h3.75M3 12h3.75m0-9v18m6.75-18h3.75M12 12h3.75M21 3v18M18.75 3H21m-2.25 0h-3.75m0 0H12m-3.75 0H3m0 0v18m0 0h3.75m0 0h5.25m6.75 0h2.25M12 21h3.75" />
  </svg>
);

export default UtensilsIcon;